import React, { useState, useEffect, useCallback, useReducer, useContext } from "react";
import { Typography, Row, Col, Modal, Flex, Input } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  templateCategory,
  templateLibraryData,
} from "../../../constant/templateLibrary";
import TemplatePreview from "../../../../../components/commonComponents/templates/TemplatePreview";
import ListTemplatePreview from "../../../components/templates/newDesignes/TemplateGridView";
import { Skeleton } from "antd";
import { Divider } from "antd";
import NewAlert from "../../../../../components/commonComponents/modal/alert/NewAlert";
import TemplateName from "../../../components/templates/TemplateName";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import { ICONS } from "../../../../../assets/icons";
import ChannelDropDown from "../../../components/whatsapp/ChannelDropDown";
import { templateLanguages } from "../../../constant/template";
import useToggle from "../../../../../hooks/useToggle";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NotificationContext from "../../../../../providers/NotificationProvider";
import { showErrorToast } from "../../../../../../src/components/commonComponents/gxAntdToast/toastUtils";

import TemplatePreviewModal from "../messageTemplate/components/TemplatePreviewModal";
import { duplicateTemplate } from "../../../api/Api";
import { updateTemplateDetails } from "../../../../../reduxToolkit/templateSlice";
import {
  createTemplate,
  createTemplateFromLibrary,
} from "../../../../../reduxToolkit/channelSlice";
import {
  INITIAL_STATE,
  templateReducer,
} from "../../../reducers/templateReducer";

const { Title } = Typography;

const categoryList = templateCategory.map((item) => ({
  id: item.id,
  name: item.name,
  value: item.name,
  checked: false,
}));

const languages = templateLanguages.map((item) => ({
  id: item.id,
  name: item.name,
  value: item.value,
  checked: false,
}));

const TemplateLibrary = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentBrand } = useSelector((store) => store.app);
  const { businessProfile } = useSelector((store) => store.Channel);
  const brand_id = currentBrand?.brand_id;

  // Initialize state with the initial template data
  const [templates, setTemplates] = useState(templateLibraryData);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1); // Track page for pagination
  const [searchText, setSearchText] = useState("");
  const [filterCategoryList, setFilterCategoryList] = useState(categoryList);
  const [filterLanguageList, setFilterLanguageList] = useState(languages);
  const [templateNameError, setTemplateNameError] = useToggle(false);
  const [newTemplateName, setNewTemplateName] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [useTemplateModalOpen, setUseTemplateModalOpen] = useState(false);
  const [_, templateDispatch] = useReducer(templateReducer, INITIAL_STATE);
  const toast = useContext(NotificationContext);  

  const getFilteredTemplates = () => {
    // Get checked category and language ids
    const checkedCategoryIds = filterCategoryList
      .filter((item) => item.checked)
      .map((item) => item.id);
    const checkedLanguageIds = filterLanguageList
      .filter((item) => item.checked)
      .map((item) => item.id);
    return templateLibraryData.filter((template) => {
      const matchesName = template.name
        .toLowerCase()
        .includes(searchText.toLowerCase());
      const matchesLanguage =
        checkedLanguageIds.length > 0
          ? checkedLanguageIds.includes(template.whatsapp_language_id)
          : true;
      const matchesCategory =
        checkedCategoryIds.length > 0
          ? checkedCategoryIds.includes(template.whatsapp_category_id)
          : true;
      return matchesName && matchesLanguage && matchesCategory;
    });
  };

  useEffect(() => {
    setTemplates(getFilteredTemplates());
  }, [searchText, filterCategoryList, filterLanguageList]);

  const loadTemplateList = () => {
    setTimeout(() => {
      setTemplates((prevTemplates) => [
        ...prevTemplates,
        ...templateLibraryData.slice(0, 10).map((item, index) => ({
          ...item,
          id: prevTemplates.length + index + 1,
          name: `Sample ${prevTemplates.length + index + 1}`,
        })),
      ]);
      setHasMore(templates.length < 200);
      setPage((prevPage) => prevPage + 1);
    }, 1000);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedTemplate(null);
    setUseTemplateModalOpen(false);
    setNewTemplateName("");
  };

  const openModal = (template) => {
    const template_category = templateCategory
      .find((cat) => cat.id === template.whatsapp_category_id)
      ?.name.toUpperCase();
    setModalOpen(true);
    setSelectedTemplate({
      ...template,
      language: templateLanguages.find(
        (lang) => lang.id === template.whatsapp_language_id,
      )?.value,
      category: templateCategory
        .find((cat) => cat.id === template.whatsapp_category_id)
        ?.name.toUpperCase(),
      subcategory_type:
        template_category == "MARKETING" ? "CUSTOM" : template_category,
      status: "APPROVED",
      template_id: 1,
    });
  };

  const openUseTemplateModal = (template) => {
    const template_category = templateCategory
      .find((cat) => cat.id === template.whatsapp_category_id)
      ?.name.toUpperCase();
    setUseTemplateModalOpen(true);
    setSelectedTemplate(() => {
      const update_data = {
        ...template,
        language: templateLanguages.find(
          (lang) => lang.id === template.whatsapp_language_id,
        )?.value,
        category: templateCategory
          .find((cat) => cat.id === template.whatsapp_category_id)
          ?.name.toUpperCase(),
        subcategory_type:
          template_category == "MARKETING" ? "CUSTOM" : template_category,
        status: "APPROVED",
        template_id: 1,
      };
      dispatch(updateTemplateDetails({ data: update_data }));
      return update_data;
    });
  };

  const handleUseTemplate = () => {
    const category = templateCategory
      .find((cat) => cat.id === selectedTemplate.whatsapp_category_id)
      ?.name.toUpperCase();
    const language = templateLanguages.find(
      (lang) => lang.id === selectedTemplate.whatsapp_language_id,
    )?.value;

    const payload = {
      brand_id,
      category: category,
      language: language,
      name: newTemplateName,
      components: selectedTemplate.components,
      subcategory_type: category === "MARKETING" ? "CUSTOM" : category,
    };

    submitAction(payload, selectedTemplate);
  };

  const submitAction = (payload, data) => {
    if (["CAROUSEL"].includes(payload?.subcategory_type)) {
      // todo: create carousel from library logics goes here
    } else if (!["CAROUSEL"].includes(data?.subcategory_type)) {
      dispatch(createTemplateFromLibrary(payload))
        .unwrap()
        .then((res) => {

          const updatedData = {
            ...data,
            id: res?.template?.id,
            name: payload?.name,
          };

          dispatch(updateTemplateDetails({ data: updatedData }));

          templateDispatch({
            type: "update_template",
            data: updatedData,
          });


          if (res?.type === "whatsapp/create_template_from_library/fulfilled") {
            navigate(
              "/user/channels/whatsapp/duplicate-template/template-details",
            );
          }
        })
        .catch((error) => {
          showErrorToast(toast, error?.message);
        });
    }
  };

  return (
    <div>
      <Title style={{ marginBottom: "1rem" }} level={4}>
        Template Library
      </Title>
      <div
        id="main-scrollable-div"
        className="h-[90vh] rounded-md bg-white px-6 py-6 overflow-scroll"
        style={{ overflowX: "visible" }}
      >
        {/* Filters */}
        <Flex justify="space-between" align="center">
          <Input
            prefix={<SearchOutlined />}
            placeholder="Search"
            className="max-w-[15vw] bg-[#F4F6F8]"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />

          <Flex gap={12}>
            <ChannelDropDown
              dropDownLabel="Category"
              dropdownHeader="Category"
              dropDownList={filterCategoryList}
              onchange={(val) => {
                setFilterCategoryList((prev) => {
                  return prev.map((item) => {
                    if (val === item.id) {
                      return {
                        ...item,
                        checked: !item.checked,
                      };
                    }
                    return item;
                  });
                });
              }}
              onClear={() => setFilterCategoryList(categoryList)}
              listLoading={false}
            />
            <ChannelDropDown
              dropDownLabel="Language"
              dropdownHeader="Language"
              dropDownList={filterLanguageList}
              onchange={(val) => {
                setFilterLanguageList((prev) => {
                  return prev.map((item) => {
                    if (val === item.id) {
                      return {
                        ...item,
                        checked: !item.checked,
                      };
                    }
                    return item;
                  });
                });
              }}
              onClear={() => setFilterLanguageList(languages)}
              listLoading={false}
            />
          </Flex>
        </Flex>
        <Divider />
        {/* Preview Model */}
        <TemplatePreviewModal
          isOpen={modalOpen}
          onClose={closeModal}
          selectedTemplate={selectedTemplate}
        />

        {/* Use Template Model */}
        <Modal
          footer={null}
          open={useTemplateModalOpen}
          onCancel={closeModal}
          destroyOnClose
          styles={{ content: { padding: 0 } }}
        >
          <NewAlert
            type="new"
            icon={ICONS?.pencil}
            handleYes={handleUseTemplate}
            handleNo={() => setUseTemplateModalOpen(false)}
            content={
              <div>
                <p>What would you like to call this template</p>
                <TemplateName
                  type={"duplicate"}
                  onChange={(val) => {
                    setNewTemplateName(val);
                  }}
                  rootClassName="!px-0 !pt-0"
                  error={templateNameError}
                  onErrorChange={(value) => {
                    setTemplateNameError(value);
                  }}
                />
              </div>
            }
            title={"Use Template?"}
            yesName="Cancel"
            noName="Use"
            // disabled={duplicateTemplateName === "" || templateNameError}
            loading={false}
            buttonColor="var(--primary)"
            ButtonClick="create-button"
          />
        </Modal>

        {/* Template List */}
        <InfiniteScroll
          dataLength={templates.length}
          next={loadTemplateList}
          hasMore={false}
          loader={<Skeleton paragraph={{ rows: 1 }} active />}
          endMessage={<Divider plain>It is all, nothing more 🤐</Divider>}
          scrollableTarget="main-scrollable-div"
        >
          <Row gutter={[16, 16]} align="stretch">
            {templates.map((item) => {
              const header = item.components.find(
                (comp) => comp.type.toUpperCase() === "HEADER",
              );

              const headerType = header?.format;
              let header_value = "";
              switch (headerType) {
                case "IMAGE":
                  header_value = header?.example?.header_handle[0];
                  break;
                case "TEXT":
                  header_value = header?.example?.header_text[0];
                  break;
                case "VIDEO":
                  header_value = header?.example?.header_handle[0];
                  break;
                case "DOCUMENT":
                  header_value = header?.example?.header_handle[0];
                  break;
                default:
                  break;
              }
              return (
                <Col
                  key={item.id}
                  xs={24}
                  sm={24}
                  md={12}
                  lg={8}
                  xl={6}
                  style={{ display: "flex" }}
                >
                  <ListTemplatePreview
                    selectTemplate={openModal}
                    body={
                      item.components.find(
                        (comp) => comp.type.toUpperCase() === "BODY",
                      )?.text
                    }
                    header={header_value}
                    header_type={headerType}
                    footer={
                      item.components.find(
                        (comp) => comp.type.toUpperCase() === "FOOTER",
                      )?.text
                    }
                    language={
                      templateLanguages.find(
                        (lang) => lang.id === item.whatsapp_language_id,
                      )?.value
                    }
                    template_type={
                      templateCategory.find(
                        (cat) => cat.id === item.whatsapp_category_id,
                      )?.name
                    }
                    template_name={item.name}
                    template={item}
                    onClickUseButton={openUseTemplateModal}
                  />
                </Col>
              );
            })}
          </Row>
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default TemplateLibrary;
